import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@nxt-costco-com/forge-components';
import { AccordionFormEntry } from 'src/components/CookieSettings/AccordionFormEntry';
import { AppActionTypes } from 'src/types';
import type { FunctionalAccordionProps } from 'src/components/CookieSettings/FunctionalAccordion/types.ts';

export const FunctionalAccordion: FC<FunctionalAccordionProps> = ({ state, dispatch }: FunctionalAccordionProps) => {
    const { t } = useTranslation('translation');

    return (
        <AccordionFormEntry
            title={t('accordians.functional.name')}
            isOptedIn={state.optInFunctional}
            setOptIn={(value) =>
                dispatch({
                    payload: value,
                    type: AppActionTypes.SET_OPT_IN_PERSONALIZED_FUNCTIONAL,
                })
            }
            categoryKey="functional"
        >
            <Text variant='b2'>{t('accordians.functional.description')}</Text>
        </AccordionFormEntry>
    );
};
